import { CfmpContainer } from '../containers/Cfmp'

/**
 * The Cfmp page.
 */
const CfmpPage = () => {
  return <CfmpContainer />
}

export default CfmpPage
